import { QueryClient } from '@tanstack/react-query';

/**
 * Remote reads go through this client.
 *
 * Cards, decks, and reviews are studied from the on-device replica and synced
 * in batches (see src/sync). This cache is only for account data that lives
 * on Supabase: the session and cloud backups. Defaults stay quiet so a focus
 * change does not turn into a burst of requests on the free plan.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
